<template>
  <div>
    <PageLinks
      :page="page"
      :links="links"
      :createLink="createLink"
      :updateLink="updateLink"
      :deleteLink="deleteLink"
    />
  </div>
</template>

<script>
import PageLinks from './PageLinks'

export default {
  props: {
    page: Object,
    links: Array,
    createLink: Function,
    updateLink: Function,
    deleteLink: Function,
  },
  components: {
    PageLinks,
  },
}
</script>
